import { useCallback } from "react";
import { useTheme } from "@mui/material/styles";
import { useWindowSize } from "react-use";
const useSize = (theme) => {
    const { height, width } = useWindowSize();
    const currentTheme = useTheme();
    const activeTheme = theme !== null && theme !== void 0 ? theme : currentTheme;
    /**
     * `true` if the window width is equal to or above the specified size
     * @param size the size to check, as a number of pixels OR a breakpoint (xs, sm, md, lg, xl)
     * @returns
     */
    const isUp = useCallback((size) => {
        if (typeof size === "number") {
            return width >= size;
        }
        return width >= activeTheme.breakpoints.values[size];
    }, [width, activeTheme.breakpoints.values]);
    /**
     * `true` if the ewindow width is below the specified size
     * @param size the size to check, as a number of pixels OR a breakpoint (xs, sm, md, lg, xl)
     * @returns
     */
    const isDown = useCallback((size) => {
        if (typeof size === "number") {
            return width < size;
        }
        return width < activeTheme.breakpoints.values[size];
    }, [width, activeTheme.breakpoints.values]);
    return {
        isUp,
        isDown,
        width,
        height,
    };
};
export default useSize;
